<template>
  <div class="icon-item">
    <div class="row g-2">
      <div class="col-auto" :title="item.title">
        <svg class="bi" fill="currentColor" width="16" height="16">
          <use :xlink:href="asset" />
        </svg>
      </div>
      <div class="col" :title="item.text">{{ item.text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconItem",
  components: {},
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    asset: function() {
      return require(`bootstrap-icons/bootstrap-icons.svg`) + '#' + this.item.icon;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/styles/_variables";
.icon-item {
  font-size: 0.9rem;
}

.row {
  flex-wrap: nowrap;

  .col {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

svg {
  margin-top: -3px;
}
</style>
